import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import AthOnboarding from './AthOnboarding';
import {Helmet} from "react-helmet";

import { quizStyle, quizStyleMobile } from '../../utils/styles';
import Name from '../../../views/onboarding/Name';
import Account from './Account';



import AthOnboardingMultiple from '../../components/onboarding/v1/AthOnboardingMultiple';
import AthOnboardingProducts from '../../components/onboarding/AthOnboardingProducts';
import Picture from '../../../views/onboarding/Picture';
import AthSteps from '../../components/onboarding/v1/AthSteps';

import { ChatContainerWrapper,ChatContainer } from '../../utils/styles';

import * as aaUtil from '../../utils/aaUtils';
import {isMobile} from "../../../utils/util"

import './AthOnboarding.css';

class AthOnboardingContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stage: 0,
            width: document.documentElement.clientWidth,
            redirectToHome: false,
            progress:0,
            isAgreement:true,
        };

        this.updateStage = this.updateStage.bind(this);
        this.redirectToHome = this.redirectToHome.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleMediaQueries.bind(this), false);
        if (this.props.location.search.includes("gift")) {
            localStorage.setItem("gift_user", true);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleMediaQueries.bind(this), false);
    }

    handleMediaQueries() {
        this.setState({
            width: document.documentElement.clientWidth
        });
    }


    updateStage(stage) {
        this.setState({ stage: stage });
    }
    updateProgress(progress) {
      this.setState({ progress: progress });
    }

    redirectToHome() {
        this.setState({redirectToHome: true});
    }

    handleAgreement(e){
        e.preventDefault();
        this.setState({
            isAgreement: false            
        },()=>{
            localStorage.setItem("isAgreement",'true')
        })
    }

    handleAccept(e){
        e.preventDefault();
        this.setState({
            isAgreement: false            
        },()=>{
            window.location.href = "http://www.allthingshair.com/en-us";            
        })
    }

    render() {

        const startOfStepsWhenNotSignin =
        [
            {
                id: 'Q1_1',
                message: "Hey! I'm Ava, your smart haircare consultant — welcome to the future of haircare and style. Let me help you find the right haircare products in seconds.",
                trigger: ({ value, steps }) => {
                    return 'Q1';
                }
            },
            {
                id: 'Q1',
                message: "What’s your hair length?",
                trigger: ({ value, steps }) => {
                    this.updateStage(1);
                    return 'A1';
                }
            },

            {
                id: 'A1',
                options: [
                    { value: '1', label: "Short", trigger: 'Q2' },
                    { value: '2', label: "Medium", trigger: 'Q2' },
                    { value: '3', label: "Long", trigger: 'Q2' },
                ]
            },

            {
                id: 'Q2',
                message: 'Is your natural hair type:',
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                      steps["Q1"].message,
                      steps["A1"].message,
                      "Q1"
                    );
                  return 'A2';
                }
            },
            {
                id: 'A2',
                options: [
                    { value: '1', label: 'Straight', trigger: 'Q3' },
                    { value: '2', label: 'Wavy', trigger: 'Q3' },
                    { value: '3', label: 'Curly', trigger: 'Q3' },
                    { value: '5', label: 'Coily', trigger: 'Q3' }
                ]
            },
            {
                id: 'Q3',
                message: 'Is your hair texture:',
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                        steps["Q2"].message,
                        steps["A2"].message,
                        "Q2"
                    );
                  return 'A3';
                }
            },
            {
                id: 'A3',
                options: [
                    { value: '1', label: 'Fine', trigger: 'Q4' },
                    { value: '2', label: 'Medium', trigger: 'Q4' },
                    { value: '3', label: 'Thick', trigger: 'Q4' },
                    { value: '4', label: 'Coarse', trigger: 'Q4' },
                ]
            },
            {
                id: 'Q4',
                message: 'How would you describe your scalp?',
                trigger: ({ value, steps }) => {
                  aaUtil.event24_view_question(
                    steps["Q3"].message,
                    steps["A3"].message,
                    "Q3"
                  );
                  this.updateProgress(30);
                  return 'A4';
                }
            },
            {
                id: 'A4',
                options: [
                    { value: '1', label: 'Dry', trigger: 'Q5' },
                    { value: '2', label: 'Normal', trigger: 'Q5' },
                    { value: '3', label: 'Greasy', trigger: 'Q5' },
                ]
            },

            {
                id: 'Q5',
                message: 'What are your top 3 hair goals ?',
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                        steps["Q4"].message,
                        steps["A4"].message,
                        "Q4"
                    );
                    this.updateProgress(40);
                    return 'A5';
                }
            },
            {
                id: 'A5',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                      { key: '1', value: '1', label: 'Smoothness' },
                      { key: '2', value: '2', label: 'Strengthen' },
                      { key: '3', value: '3', label: 'Keep colour vibrant' },
                      { key: '4', value: '4', label: 'Frizz Control' },
                      { key: '5', value: '5', label: 'Volumize' },
                      { key: '6', value: '6', label: 'Dandruff Control' },
                      { key: '7', value: '7', label: 'Hydrate' },
                      { key: '8', value: '8', label: 'Hair Loss Control' },
                      { key: '9', value: '9', label: 'Shine' },
                      { key: '10', value: '10', label: 'Split ends Control' },
                      { key: '11', value: '11', label: 'Cleaning and refresh' },
                      { key: '12', value: '12', label: 'Curl definition' }
                  ]
                  }
                  maxSelectSize = {3}
                />,
                waitAction: true,
                trigger: ({ value, steps }) => {
                  return 'Q6';
                }
            },


            {
                id: 'Q6',
                message: 'What products does your routine involve? Select all that apply',
                trigger: ({ value, steps }) => {
                    this.updateProgress(50);
                    this.updateStage(2);
                    aaUtil.event24_view_question(
                        steps["Q5"].message,
                        steps["A5"].value[1],
                        "Q5"
                    );
                    return 'A6';
                }
            },
            {
                id: 'A6',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                      { key: '1', label: 'Shampoo' },
                      { key: '2', label: 'Conditioner' },
                      { key: '3', label: 'Hair Mask' },
                      { key: '5', label: 'Serum' },
                      { key: '4', label: 'Leave-In Conditioner or Heat Protectant' },
                      { key: '6', label: 'Oil' },
                      { key: '7', label: 'Dry Shampoo' },
                      { key: '8', label: 'Hair Spray or Texturizing Spray' },
                  ]
                  }
                />,
                waitAction: true,
                trigger: ({ value, steps }) => {
                  return 'Q7';
                }
            },


            {
                id: 'Q7',
                message: 'How do you generally style your hair?',
                trigger: ({ value, steps }) => {
                    this.updateProgress(55);
                    aaUtil.event24_view_question(
                        steps["Q6"].message,
                        steps["A6"].value[1],
                        "Q6"
                    );
                    return 'A7';
                }
            },
            {
                id: 'A7',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                      { key: '1', label: 'Flat-Ironing' },
                      { key: '2', label: 'Blow Drying' },
                      { key: '3', label: 'Curling Ironing' },
                      { key: '4', label: 'Straightening or Waving' },
                      { key: 'SKIP', label: 'Like it natural' },
                  ]
                  }
                />,
                waitAction: true,
                trigger: ({ value, steps }) => {
                  return 'Q8';
                }
            },

            {
                id: 'Q8',
                message: 'Which other actions do you occasionally take? Select all that apply.',
                trigger: ({ value, steps }) => {
                    this.updateProgress(60);
                    var value =  steps["A7"].value[1];
                    if(steps["A7"].value[1].indexOf("skip") != -1){
                        value = 'Like it natural';
                    }
                    aaUtil.event24_view_question(
                        steps["Q7"].message,
                        value,
                        "Q7"
                    );
                    return 'A8';
                }
            },
            {
                id: 'A8',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                      { key: '1', label: 'Colouring' },
                      { key: '2', label: 'Bleaching' },
                      { key: '3', label: 'Chemical treatment' },
                      { key: 'SKIP', label: 'Leave it natural' },
                  ]
                  }
                />,
                waitAction: true,
                trigger: ({ value, steps }) => {
                  return 'Q9';
                }
            },

            {
                id: 'Q9',
                message: 'What styles do you wear or would like to? Select all that apply.',
                trigger: ({ value, steps }) => {
                    this.updateProgress(70);
                    var value =  steps["A8"].value[1];
                    if(steps["A8"].value[1].indexOf("skip") != -1){
                        value = 'Like it natural';
                    }
                    aaUtil.event24_view_question(
                        steps["Q8"].message,
                        value,
                        "Q8"
                    );
                    return 'A9';
                }
            },
            {
                id: 'A9',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                      { key: '1', label: 'Volumized' },
                      { key: '2', label: 'Waves or Curls' },
                      { key: '3', label: 'Short' },
                      { key: '5', label: 'Hijab' },
                      { key: '4', label: 'Smooth and Straight' },
                      { key: '6', label: 'Top Knot' },
                      { key: '7', label: 'Braids' },
                      { key: '8', label: 'Ponytail or Updo' },
                      { key: '9', label: 'Leave it natural' },
                  ]
                  }
                />,
                waitAction: true,
                trigger: ({ value, steps }) => {
                  return 'Q10';
                }
            },

            {
                id: 'Q10',
                message: 'What’s the end look you want after styling your hair?',
                trigger: ({ value, steps }) => {
                    this.updateProgress(80);
                    aaUtil.event24_view_question(
                        steps["Q9"].message,
                        steps["A9"].value[1],
                        "Q9"
                    );
                    return 'A10';
                }
            },
            {
                id: 'A10',
                options: [
                    { value: '1', label: "Straight hairstyle", trigger: 'Q11' },
                    { value: '2', label: "Wavy hairstyle", trigger: 'Q11' },
                    { value: '3', label: "Curly hairstyle", trigger: 'Q11' },
                ]
            },

            {
                id: 'Q11',
                message: "What's your gender?",
                trigger: ({ value, steps }) => {
                    this.updateProgress(90);
                    aaUtil.event24_view_question(
                        steps["Q10"].message,
                        steps["A10"].message,
                        "Q10"
                    );
                    return 'A11';
                }
            },
            {
                id: 'A11',
                options: [
                    { value: '1', label: "Female", trigger: 'Q12' },
                    { value: '2', label: "Male", trigger: 'Q12' },
                    { value: '3', label: "Prefer not to disclose", trigger: 'Q12' },
                ]
            },


            {
                id: 'Q12',
                message: "Before we share an analysis, please sign up for our newsletter and get hair tips and product news from All Things Hair.",
                
                trigger: ({ value, steps }) => {
                    this.updateStage(3);
                    this.updateProgress(100);
                    aaUtil.event24_view_question(
                        steps["Q11"].message,
                        steps["A11"].message,
                        "Q11"
                    );
                    return 'A13';
                }
            },
            {
                id: 'A13',
                component: <Account ath={true} answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q14'
            },
            {
                id: 'Q14',
                message: "Thank you for completing the detailed evaluation! We are calculating your hair type, regimen, and recommendations now!",
                end: true
            }

        ];

        
        let steps = [];
        steps = startOfStepsWhenNotSignin;

        // const stage = this.state.stage;

        return (
          <ChatContainerWrapper id="onboarding-container-wrapper" /* className="ath-onboarding-container-wrapper" /*style={ this.state.width > 813 ? quizStyle : quizStyleMobile }*/>
              <Helmet>
                <title>Onboarding Survey - HelloAva</title>
                <meta name="description" content="What are your primary skin care concerns?  Answer Ava's questions to unlock your best skin care products and routine." />
              </Helmet>
                <AthOnboarding steps={ steps }  />

              <AthSteps step={this.state.stage} progress={this.state.progress}/>

              <div className="bottom-banner-agreement" style={this.state.isAgreement ? {display: 'block'} : {display: 'none'}}>
                <span className="agreement-close-icon" onClick={(e)=>{ this.handleAgreement(e) }}></span>
                <div className="agreement-top-row-text">This experience uses cookies which are shared with our trusted partner Helloava, to provide you with personalized recommendations.</div>
                <div className="agreement-top-row-text-2">Don`t worry your data is being kept strictly confidential and will not be shared with any third party companies. For more information please refer to their 
                    <a href="https://helloava.co/privacy" target={ isMobile(navigator.userAgent) ? "_self" : "_blank" }  className="agreement-link">PRIVACY POLICY.</a>
                </div>
                <button className="agreement-button" onClick={(e)=>{ this.handleAgreement(e) }}>I Accept</button>
                <div className="ath-accpet" onClick={(e)=>{ this.handleAccept(e) }}>I don’t accept</div>
              </div>
              {/*<div className="ath-onboarding__onboarding-container"}
                  
              </div>*/}
          </ChatContainerWrapper>
        );
    }
}

export default withRouter(connect()(AthOnboardingContainer))



// WEBPACK FOOTER //
// ./src/ath/views/v1/AthOnboardingContainer.js